module.exports = __webpack_public_path__ + "static/img/news.7d7399da.webp";